import { render } from "./CurriculumTab.vue?vue&type=template&id=0abf45aa"
import script from "./CurriculumTab.vue?vue&type=script&lang=js"
export * from "./CurriculumTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__